import { useEffect, useState } from "react";
import Noimage from "../../images/3.png";
import "./GiftandArts.css"; // shared CSS for responsiveness

function SingleProductGiftsAndArts() {
  const productId = sessionStorage.getItem("productId");

  const [product, setProduct] = useState([]);
  const [productImg, setProductImg] = useState([]);
  const [mainImage, setMainImage] = useState("");

  useEffect(() => {
    if (productId) {
      fetchProductDetails();
      fetchProductImages();
    }
  }, [productId]);

  async function fetchProductDetails() {
    try {
      const res = await fetch(`/allGiftsAndArtsByPID/${productId}`);
      const data = await res.json();
      setProduct(data);
    } catch (err) {
      console.error("Error fetching product:", err.message);
    }
  }

  async function fetchProductImages() {
    try {
      const res = await fetch(`/allProductsMediaByPID/${productId}`);
      const data = await res.json();
      setProductImg(data);
      if (data.length > 0) {
        setMainImage(`data:image/png;base64,${data[0].productImages}`);
      }
    } catch (err) {
      console.error("Error fetching images:", err.message);
    }
  }

  const handleThumbnailClick = (img) => {
    setMainImage(`data:image/png;base64,${img.productImages}`);
  };

  const renderSpec = (label, value) => {
    if (!value) return null;
    return (
      <div className="spec-row">
        <strong className="spec-label">{label}:</strong>
        <span>{value}</span>
      </div>
    );
  };

  return (
    <>
      <div className="product-container">
        {/* Image Section */}
        <div className="product-images">
          <div className="thumbnail-list">
            {productImg.map((img, idx) => (
              <img
                key={idx}
                src={
                  img.productImages
                    ? `data:image/png;base64,${img.productImages}`
                    : Noimage
                }
                alt="thumb"
                className="thumbnail-image"
                onClick={() => handleThumbnailClick(img)}
              />
            ))}
          </div>
          <div className="main-image-wrapper">
            <img
              src={mainImage || Noimage}
              alt="Main Product"
              className="main-image"
            />
          </div>
        </div>

        {/* Info Section */}
        <div className="product-details">
          {product.map((prdct) => (
            <div key={prdct.productID}>
              <h2 className="product-title">{prdct.productName}</h2>
              <p>
                <strong>Price:</strong>{" "}
                <span className="price-text">₹{prdct.price}</span>
              </p>
              <p>
                <strong>Color:</strong> {prdct.color}
              </p>
              <p>
                <strong>Age Group:</strong> {prdct.ageGroup}
              </p>
              <p>
                <strong>Brand:</strong> {prdct.brand}
              </p>

              <a
                href={`https://wa.me/919490384177?text=Hi, I'm interested in buying the product: ${encodeURIComponent(
                  prdct.productName
                )}, Price: ₹${prdct.price}`}
                target="_blank"
                rel="noopener noreferrer"
                className="whatsapp-button"
              >
                Shop on WhatsApp
              </a>
            </div>
          ))}
        </div>
      </div>

      {/* Specs */}
      {product.map((prdct) => (
        <div className="product-spec-container" key={`desc-${prdct.productID}`}>
          <div className="product-desc-block">
            <h4>Description</h4>
            <p>{prdct.description}</p>
          </div>

          <div className="product-spec-block">
            <h4>Specifications</h4>

            <h5 className="section-heading">General</h5>
            <div className="grid-spec">
              {renderSpec("Type", prdct.type)}
              {renderSpec("Model Number", prdct.modelNumber)}
              {renderSpec("Color", prdct.color)}
              {renderSpec("Speed", prdct.speed)}
              {renderSpec("Weight", prdct.weight)}
              {renderSpec("Country of Origin", prdct.countryOfOrigin)}
              {renderSpec("Manufacturer", prdct.manufacturer)}
            </div>

            <h5 className="section-heading">Power Features</h5>
            <div className="grid-spec">
              {renderSpec("Battery Type", prdct.batteryType)}
              {renderSpec(
                "Battery Included",
                prdct.batteryIncluded ? "Yes" : "No"
              )}
              {renderSpec("Rechargeable", prdct.rechargeable ? "Yes" : "No")}
            </div>

            <h5 className="section-heading">Convenience Features</h5>
            <div className="grid-spec">
              {renderSpec(
                "Parental Remote",
                prdct.parentalRemote ? "Yes" : "No"
              )}
              {renderSpec(
                "MP3 Player Supported",
                prdct.mpThreePlayerSupported ? "Yes" : "No"
              )}
              {renderSpec(
                "Other Convenience Features",
                prdct.otherConvenienceFeatures
              )}
            </div>

            <h5 className="section-heading">Dimensions</h5>
            <div className="grid-spec">
              {renderSpec("Dimensions", prdct.dimentions)}
              {renderSpec("Maximum User Weight", prdct.maximumUserWeight)}
            </div>

            <h5 className="section-heading">Warranty</h5>
            <div className="grid-spec">
              {renderSpec("Warranty", prdct.warrenty)}
              {renderSpec("Covered in Warranty", prdct.coveredInWarranty)}
              {renderSpec(
                "Not Covered in Warranty",
                prdct.notCoveredInWarranty
              )}
            </div>
          </div>
        </div>
      ))}
    </>
  );
}

export default SingleProductGiftsAndArts;
